// @flow
export { default } from './OrderInvoiceTemplate';



// WEBPACK FOOTER //
// ./src/components/order/OrderInvoiceTemplate/index.js